import script from "./fixedClass.vue?vue&type=script&setup=true&lang=js"
export * from "./fixedClass.vue?vue&type=script&setup=true&lang=js"

import "./fixedClass.vue?vue&type=style&index=0&id=1b3354cb&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b3354cb"]])

export default __exports__